"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyArrayForDynamo = exports.domainWhiteList = exports.defaultDateFormat = void 0;
exports.defaultDateFormat = 'YYYY-MM-DD HH:mm:ss';
exports.domainWhiteList = [
    'https://dev-studio-v2.flarie.com',
    'https://dev-studio.flarie.com',
    'https://dev-game.flarie.com',
    'https://dev-gamecenter.flarie.com',
    'https://dev-integration.flarie.com',
    'https://staging-studio.flarie.com',
    'https://staging-game.flarie.com',
    'https://staging-gamecenter.flarie.com',
    'https://staging-integration.flarie.com',
    'https://studio.flarie.com',
    'https://game.flarie.com',
    'https://gamecenter.flarie.com',
    'https://integration.flarie.com',
    'https://games.app.ingoapp.com',
    'https://api.flarie.com',
    'http://localhost:9100',
    'http://localhost:9001',
    'http://localhost:9002',
    'https://localhost:9100', // studio-app with https support
    'http://localhost:9010', // game-engine-server
];
exports.emptyArrayForDynamo = [[][0]];
